// src/utils/linkDetect.js — browser copy of api/_link-detect.js.
//
// The composer uses this to explain the no-links rule BEFORE a member posts
// (UX spec member-replies.md §4.4). The server copy is the one that ENFORCES.
// Keep byte-identical below the header — scripts/link-detect-parity.mjs checks.
// ── shared body ──
const LINK_RE = /(https?:\/\/\S+)|(\bwww\.\S+)|([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})|(\b[A-Z0-9][A-Z0-9-]*(?:\.[A-Z0-9-]+)*\.(?:com|net|org|co|io|us|uk|ca|au|shop|store|app|ly|me|info|biz|xyz|link|site|online|club|gg|tv|page|bio|life|fit|health|coach|courses?)\b(?:\/\S*)?)/i;

export function hasLink(text) {
    return LINK_RE.test(String(text || ''));
}
